// ProjectCppPanel — CPP/PCI records scoped to one project (used in the
// Project detail "CPP / PCI" tab). Thin wrapper, mirrors ProjectRamsPanel.
import CppListPage from "@/pages/cpp/CppListPage";

export default function ProjectCppPanel({ projectId, clientId }) {
    return <CppListPage presetClientId={clientId} presetProjectId={projectId} compact />;
}
